var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M16.483 2.505c.69.673.69 1.765 0 2.438L9.26 12l7.223 7.057c.69.673.69 1.765 0 2.438a1.794 1.794 0 0 1-2.495 0l-8.471-8.276a1.696 1.696 0 0 1 0-2.438l8.47-8.276a1.794 1.794 0 0 1 2.496 0",
    clipRule: "evenodd"
  })));
};
export default SvgChevronLeft;